import React, { useState } from 'react'
import './cards.css'
import image from '../../assets/images/expense.png'
import useClickOutside from '../../useClickOutside'
import { formatNumberWithCommas } from '../general/general-component/abstruct-component/FunctionRemoveCommas'
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom'

function ExpensesCard({ langLocal, expense, translate, index, warning, detailsOfExpenses }) {
    const [options, setOptions] = useState(false)

    const { currency } = useSelectorCustom();
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    return (
        <div className='one-expenses5 card-hover' >
            {
                expense?.revolving === 1 || expense?.revolving === true  && (
                    <span className='Revolving' >{translate('revolved')}</span>
                )
            }

            <div>
                <i style={langLocal === 'ar' ? { position: "absolute", left: '10px' } : { position: "absolute", right: '10px' }}
                    className='fa fa-ellipsis-v icon_edit' onClick={() => { setOptions(!options); setRowId(index) }}  ></i>
                {
                    options && index === row_id && (
                        <div ref={domNode} className='div-actions shadow_main2' style={langLocal === 'ar' ? { left: '20px' } : { right: '10px', top: "50px" }} >
                            <span onClick={() => warning(expense)} >{translate('delete')}</span>
                            <span onClick={() => detailsOfExpenses(expense?.id)} >{translate('details')}</span>
                        </div>
                    )
                }
            </div>
            <div style={{ display: "flex", alignItems: "center" }} >
                <img src={image} />
                <div style={langLocal === 'ar' ? { marginRight: "70px" } : { marginLeft: "70px" }} >
                    <div className='title-expensess'>{translate('invoice_number')}</div>
                    <span className='span-expenses' >{expense?.invoice_number}</span>
                </div>
            </div>

            <div style={{ width: "100%", marginTop: "10px" }} >
                <div className='d-flex-one-expenses' >
                    <div className='title-expensess' >{translate('statement')}</div>
                    <span className='span-expenses' >{expense?.expense_statement?.number}</span>
                </div>
                <div className='d-flex-one-expenses' >
                    <div className='title-expensess' >{translate('amount')}</div>
                    <span className='span-expenses' >{formatNumberWithCommas(expense?.amount)}  {' '} {translate(currency)}</span>
                </div>
                <div className='d-flex-one-expenses' >
                    <div className='title-expensess'>{translate('created_by')}</div>
                    <span className='span-expenses' >{expense?.created_by?.name}</span>
                </div>
                <p className='para-expenses' >{expense?.descriptions}</p>
            </div>
        </div>
    )
}

export default ExpensesCard